const onboardingAPIPrefix = accountId => `/${accountId}/onboarding`;

export const onboardingApiFactory = ({ callGetApi }) => ({
    getOnboardingData: ({ accountId, ...options }) => callGetApi(onboardingAPIPrefix(accountId), options),
});
